import React, { useEffect } from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import "./Contact.css";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="container contact-hero-content">
          <h1 className="animate-on-scroll">Get in Touch</h1>
          <p className="animate-on-scroll">
            We'd love to hear from you. Reach out for enquiries or just to say hello.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section contact-content">
        <div className="container">
          <div className="contact-info-center animate-on-scroll">
            <h2>Get In Touch With Us</h2>
            <p className="contact-intro">
              Have questions about our products or want to learn more about GAB Organics? We're here to help.
            </p>

            <div className="contact-details">
              <div className="contact-detail-item">
                <div className="contact-icon">
                  <Mail size={28} />
                </div>
                <div>
                  <h4>Email Us</h4>
                  <a href="mailto:support@gaborganics.com">support@gaborganics.com</a>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-icon">
                  <Phone size={28} />
                </div>
                <div>
                  <h4>Call Us</h4>
                  <a href="tel:+917736959355">+91 7736959355</a>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-icon">
                  <MapPin size={28} />
                </div>
                <div>
                  <h4>Our Location</h4>
                  <p>Trivandrum, India</p>
                </div>
              </div>
            </div>

            <div className="contact-image">
              <img 
                src="https://images.pexels.com/photos/461049/pexels-photo-461049.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
                alt="Contact us" 
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
